import type { OpenXAgentTableColumn } from './types.ts';

export const CHECKBOX_COLUMN_WIDTH = 60;

export const CHECKBOX_COLUMN: OpenXAgentTableColumn = { id: 'select', width: `${CHECKBOX_COLUMN_WIDTH}px` };
